module.exports = __webpack_public_path__ + "img/90.214497c3.png";